// extracted by mini-css-extract-plugin
export default {"apiKeys":"api-keys_apiKeys__6OTRQ","table":"api-keys_table__oO3jt"};